import React from 'react'

import { Button, Modal, ModalButtons, BodyText, Notification } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'
import { useSelector, useDispatch } from 'react-redux'

import { RootState } from 'redux/types'

import { FAVOURITES_ERROR_GROUPS } from '../../constants'
import actions from '../../duck/actions'
import { operationDeleteFavouritesItem } from '../../duck/operations'
import { getFavouritesError, getFavouritesErrorMode } from '../../duck/selectors'
import styles from '../FavouritesItemList/FavouritesItemList.scss'

const FavouritesError: React.FC = () => {
  const dispatch = useDispatch()
  const hideFavouritesError = (): void => {
    dispatch(actions.hideError())
  }
  const deleteFavouriteItem = (productCode): void => {
    dispatch(operationDeleteFavouritesItem(productCode))
  }

  const favouritesError = useSelector((state: RootState) => getFavouritesError(state))

  const favouritesErrorMode = useSelector(getFavouritesErrorMode)

  const { CHANGE_VARIANT, SAME_VARIANT, REMOVE } = FAVOURITES_ERROR_GROUPS
  let heading = ''
  let content = ''

  const deleteItemAndCloseModal = (code): void => {
    deleteFavouriteItem(code)
    hideFavouritesError()
  }

  const closeNotificationErrorBanner = (): void => {
    hideFavouritesError()
  }

  const isModalCompressed = process.env.IS_COMPRESSED_MODAL_ENABLED === 'enabled'

  if (favouritesError.errorGroup === CHANGE_VARIANT) {
    heading = 'checkout.offers.error'
    content = 'favourites.error.change.variant'
  }

  if (favouritesError.errorGroup === SAME_VARIANT) {
    heading = 'favourites.merge.popup.title'
    content = 'favourites.merge.popup.message'
  }

  if (favouritesError.errorGroup === REMOVE) {
    heading = 'checkout.offers.error'
    content = 'favourites.error.remove'
  }

  if (!favouritesError.showError) {
    return null
  }

  return (
    <>
      {favouritesErrorMode.isModal && (
        <Modal
          closeButtonText={getLabelFromStorage('general.close')}
          title={getLabelFromStorage(heading)}
          toggleModal={hideFavouritesError}
          isOpen={favouritesError.showError}
          isModalCompressed={isModalCompressed}
          closeIconSize={process.env.ERROR_MODAL_CLOSE_ICON_SIZE === 'xsmall' ? 'xsmall' : 'normal'}
        >
          <BodyText>{getLabelFromStorage(content)}</BodyText>

          {favouritesError.errorGroup === SAME_VARIANT && favouritesError.variantCode && (
            <ModalButtons bottom isModalCompressed={isModalCompressed}>
              <Button onClick={hideFavouritesError} secondary>
                {getLabelFromStorage('favourites.merge.popup.cancel')}
              </Button>

              <Button onClick={() => deleteItemAndCloseModal(favouritesError.variantCode)}>
                {getLabelFromStorage('favourites.merge.popup.confirm')}
              </Button>
            </ModalButtons>
          )}
        </Modal>
      )}
      {favouritesErrorMode.isNotificationBar && (
        <Notification
          shouldIgnoreTimeSpan
          type="error"
          isPortalEnabled={false}
          additionalClass={styles.appWrapper}
          additionalStatusMessageClass={styles.statusMessage}
          onExit={closeNotificationErrorBanner}
          contentContainerWidth={
            process.env.IS_NOTIFICATION_BAR_SMALL_CONTAINER_WIDTH_ENABLED === 'enabled'
              ? 'small'
              : 'large'
          }
        >
          {getLabelFromStorage(content)}
        </Notification>
      )}
    </>
  )
}

export default React.memo(FavouritesError)
